module.exports = __webpack_public_path__ + "static/media/fonduri.9b2d5cb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/FO/resources/img/fonduri.jpg
// module id = 1177
// module chunks = 0